import { render, staticRenderFns } from "./TheDesktopNavigation.vue?vue&type=template&id=463cb863&scoped=true"
import script from "./TheDesktopNavigation.vue?vue&type=script&lang=js"
export * from "./TheDesktopNavigation.vue?vue&type=script&lang=js"
import style0 from "./TheDesktopNavigation.vue?vue&type=style&index=0&id=463cb863&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463cb863",
  null
  
)

export default component.exports